import { FormattedMessage } from "react-intl"
import messages from "./messages"

const getFormattedMessage = (key, values = {}) => {
  return <FormattedMessage {...messages[key]} values={values} />
}

const getErrorMessage = (e) => {
  const data = e.response?.data
  const status = e.response?.status
  const text = e.response?.responseText

  let erroredField
  let erroredFieldErrorMessage
  let errorMessage
  const genericMessage = getFormattedMessage("genericError")
  let responseData = {}
  let message

  if (status >= 400 && status < 500) {
    if (data && data.non_field_errors) {
      message = data.non_field_errors
    } else if (text || data) {
      if (data) {
        responseData = data
      } else if (text) {
        responseData = JSON.parse(text)
      }
      if (responseData.non_field_errors) {
        message = responseData.non_field_errors[0]
      } else if (responseData.message) {
        message = responseData.message
      } else if (responseData.user_message) {
        message = responseData.user_message
      } else {
        // Display first field-based error message in a pop-up dialog
        erroredField = Object.keys(responseData)[0]
        erroredFieldErrorMessage = responseData[erroredField]
        erroredField = erroredField.replace(/_/g, " ")
        erroredField = erroredField.replace(/\d/g, "")
        errorMessage = getFormattedMessage("sorryInvalid", {
          erroredField,
          erroredFieldErrorMessage,
        })
        message = errorMessage
      }
    } else {
      message = genericMessage
    }
  } else {
    message = genericMessage
  }
  return message
}

// Return the incomplete step based on registration multi-purpose criteria

const getIncompleteRegistrationStep = ({
  customer,
  registrationSteps,
  tenantSettings,
}) => {
  let step
  if (customer && registrationSteps) {
    if (
      !customer.phone_number_verified &&
      registrationSteps["verification_step"]
    )
      step = "verification_step"
    else if (
      customer.identity_verification_status === "unsubmitted" &&
      registrationSteps["driving_license_step"]
    )
      step = "driving_license_step"
    else if (
      tenantSettings.skipRegistrationLicenseConfirmationScreen === false &&
      customer?.driving_license?.license_number === null &&
      registrationSteps["manual_license_correction_step"]
    )
      step = "driving_license_step"
    else if (
      !customer.mailing_address_display &&
      !tenantSettings.skipMailingAddress &&
      registrationSteps["mailing_address_step"]
    )
      step = "mailing_address_step"
    else if (
      tenantSettings.paymentsEnabled &&
      registrationSteps["credit_card_step"] &&
      customer.has_valid_payment_card === false
    ) {
      step = "credit_card_step"
    } else if (
      ["HYBRID", "BUSINESS"].includes(customer.profile_type) &&
      customer.business_registration_completed
    ) {
      step = null
    } else if (
      ["PERSONAL"].includes(customer.profile_type) &&
      customer.registration_completed
    ) {
      step = null
    }
  }
  return step
}

export { getErrorMessage, getIncompleteRegistrationStep }
